// Advisory line under the intake form's "Delivery note #" field, fed by
// useDuplicateNote. Three honest states: checking, a known repeat (with the
// earlier delivery named and linked), and "couldn't check" with whatever the
// register's loaded window can add. Nothing here blocks — Save asks.
import { Link } from 'react-router-dom'
import { fmtDateZA } from '@/lib/dates'
import type { DuplicateNoteRow, DuplicateNoteState } from '@/hooks/useDuplicateNote'

const statusWords = (s: string) => s.replace(/_/g, ' ').toLowerCase()

/** One sentence naming the earlier delivery — shared by the advisory and the Save dialog. */
export function duplicateNoteSentence(m: DuplicateNoteRow, note: string, others = 0): string {
  const more = others > 0 ? ` (and ${others} more)` : ''
  return `Note ${note.trim()} was already captured for ${m.grower} on ${fmtDateZA(m.received_at)} — ${m.bins_received} bins, ${statusWords(m.status)}${more}.`
}

export function DuplicateNoteAdvisory({ dup, note }: { dup: DuplicateNoteState; note: string }) {
  if (dup.state === 'checking') {
    return <p className="text-xs text-muted mt-1" role="status">Checking earlier deliveries for this note…</p>
  }
  if (dup.state === 'match') {
    return (
      <p className="text-xs text-amber-300 mt-1" role="status">
        ⚠ {duplicateNoteSentence(dup.match, note, dup.others)} Double entry? Save will ask.{' '}
        <Link to={`/deliveries/${dup.match.delivery_id}`} target="_blank" rel="noreferrer" className="underline">
          View it
        </Link>
      </p>
    )
  }
  if (dup.state === 'unknown') {
    return (
      <p className="text-xs text-amber-300 mt-1" role="status">
        Couldn't check earlier deliveries for this note (offline?).{' '}
        {dup.fallback
          ? `The loaded list has it: ${duplicateNoteSentence(dup.fallback, note)}`
          : 'Nothing in the loaded list — check the paper note yourself.'}
      </p>
    )
  }
  return null
}
